import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ClubPage from "./Components/ClubPage/ClubPage.jsx";
import LeafletMap from "./Components/LeafletMap/LeafletMap.jsx";

const App = () => {
  return (
    <Router basename="/c">
      <Routes>
        <Route path="/" element={<LeafletMap />} />
        <Route path="/:handle" element={<ClubPage />} />
      </Routes>
    </Router>
  );
};

export default App;
